import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Paper,
  CircularProgress,
  Slide,

  Divider,
  Checkbox,
  ListItemText,
  Switch,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  IconButton,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import EditIcon from "@mui/icons-material/Edit";

import TopHeader from "./subcomponents/TopHeader";
import BottomFooter from "./subcomponents/BottomFooter";

function CommPrefs() {
  const [clinicData, setClinicData] = useState(null);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    preferredContact: "email",
  });
  const [editEmailShow, setEmailShow] = useState(false);
  const [contactMethod, setContactMethod] = useState("primary");

  useEffect(() => {
    const demoData = {
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    };
    setClinicData(demoData);
    // Simulate API call
    /*fetch("/api/clinic-theme") // Replace with actual API endpoint
      .then((res) => res.json())
      .then((data) => setClinicData(data))
      .catch((err) => console.error("Error fetching clinic data:", err));*/
  }, []);
  const [emailPreferences, setEmailPreferences] = useState({
    appointmentReminders: false,
    classReminders: false,
    contactLensReminders: false,
    welcomeMessages: false,
    education: false,
  });

  const [smsPreferences, setSmsPreferences] = useState({
    appointmentReminders: false,
    classReminders: false,
    contactLensReminders: false,
    welcomeMessages: false,
  });

  const [phonePreferences, setPhonePreferences] = useState({
    appointmentReminders: false,
    classReminders: false,
  });

  const handleEmailChange = (event) => {
    setEmailPreferences({
      ...emailPreferences,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSmsChange = (event) => {
    setSmsPreferences({
      ...smsPreferences,
      [event.target.name]: event.target.checked,
    });
  };

  const handlePhoneChange = (event) => {
    setPhonePreferences({
      ...phonePreferences,
      [event.target.name]: event.target.checked,
    });
  };

  if (!clinicData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#F2F7FC",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Submitted Data:", formValues);
  };
  return (
    <Box
      sx={{
        backgroundImage: `url(${clinicData.backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
     {clinicData && <TopHeader clinicData={clinicData} />}
      {/* Form Section */}
      <Slide direction="up" in={true} mountOnEnter unmountOnExit>
        <Paper
          elevation={4}
          sx={{
            padding: 4,
            maxWidth: "lg",
            width: "100%",
            borderRadius: 3,
            textAlign: "center",
            backgroundColor: "#fff",
            boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
            marginTop: { xs: 5, md: 14 },
          }}
        >
          <Typography
            sx={{ mb: 3, fontWeight: "bold", color: clinicData.secondaryColor }}
          >
            Please check the boxes to express your consent and preferred method
            of communication.
          </Typography>

          {/* Email Prefereece Card */}
          <Grid
            container
            sx={{ justifyContent: "space-between" }}
            columnSpacing={{ sm: 1, md: 2 }}
          >
            <Grid item xs={12} md={4}  mt={2}>
              <ListItemText
                primary="Email Contact Preferences"
                secondary={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <span>Your email address: abc@test.com</span>
                    <IconButton
                      size="small"
                      onClick={() => setEmailShow(!editEmailShow)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                }
                sx={{ textAlign: "left" }}
              />
              {editEmailShow && (
                <Box sx={{ borderRadius: 2, bgcolor: "#F4F5F8", padding: 2 }}>
                  <TextField label="Your Email" size="small" />
                  <Box marginTop={2} marginBottom={2}>
                    <Button
                      variant="contained"
                      sx={{
                        ml: 1,
                        backgroundColor: clinicData.secondaryColor,
                        color: "#fff",
                      }}
                    >
                      Update
                    </Button>
                    {/** Cancel */}
                    <Button
                      variant="outlined"
                      sx={{ ml: 1, color: clinicData.secondaryColor }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              )}
              <FormControl size="small" sx={{ mt: 2, minWidth: 200 }}>
                <InputLabel>Contact Method</InputLabel>
                <Select
                  value={contactMethod}
                  onChange={(e) => setContactMethod(e.target.value)}
                  label="Contact Method"
                >
                  <MenuItem value="disabled" disabled>
                    Disabled
                  </MenuItem>
                  <MenuItem value="primary">Primary</MenuItem>
                  <MenuItem value="secondary">Secondary</MenuItem>
                  <MenuItem value="Tertiary">Tertiary</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              md={8}
              mt={2}
              sx={{
                flexGrow: 0,
                flexBasis: "auto",
                width: { xs: "100%", md: "67%" },
              }}
            >
              <Box sx={{ borderRadius: 3, bgcolor: "#F4F6F8", padding: 3 }}>
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Check All"
                  labelPlacement="start"
                  sx={{ 
                        justifyContent: "space-between",
                        width: "100%",
                        fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                        "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                        "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                    }}
                />
                <Divider/>
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Appointment and recall reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Glasses / Contact lens pickup reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Contact lens replacement reminders (if applicable)"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Welcome messages, appreciation follow-ups, surveys, and birthday greetings"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Specific education about my eye conditions sent by my eyecare provider"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                 <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Newsletters and promotions"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
              </Box>
            </Grid>
          </Grid>

         {/* Sms Prefereece Card */}
         <Grid
            container
            sx={{ justifyContent: "space-between", marginTop:2 }}
            columnSpacing={{ sm: 1, md: 2 }}
          >
            <Grid item xs={12} md={4}  mt={2}>
              <ListItemText
                primary="Text (SMS) Contact Preferences"
                secondary={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <span>Your mobile number: 1234567890</span>
                    <IconButton
                      size="small"
                      onClick={() => setEmailShow(!editEmailShow)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                }
                sx={{ textAlign: "left" }}
              />
              {editEmailShow && (
                <Box sx={{ borderRadius: 2, bgcolor: "#F4F5F8", padding: 2 }}>
                  <TextField label="Your Mobile Number" size="small" />
                  <Box marginTop={2} marginBottom={2}>
                    <Button
                      variant="contained"
                      sx={{
                        ml: 1,
                        backgroundColor: clinicData.secondaryColor,
                        color: "#fff",
                      }}
                    >
                      Update
                    </Button>
                    {/** Cancel */}
                    <Button
                      variant="outlined"
                      sx={{ ml: 1, color: clinicData.secondaryColor }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              )}
              <FormControl size="small" sx={{ mt: 2, minWidth: 200 }}>
                <InputLabel>Contact Method</InputLabel>
                <Select
                  value={contactMethod}
                  onChange={(e) => setContactMethod(e.target.value)}
                  label="Contact Method"
                >
                  <MenuItem value="disabled" disabled>
                    Disabled
                  </MenuItem>
                  <MenuItem value="primary">Primary</MenuItem>
                  <MenuItem value="secondary">Secondary</MenuItem>
                  <MenuItem value="Tertiary">Tertiary</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              md={8}
              mt={2}
              sx={{
                flexGrow: 0,
                flexBasis: "auto",
                width: { xs: "100%", md: "67%" },
              }}
            >
              <Box sx={{ borderRadius: 3, bgcolor: "#F4F6F8", padding: 3 }}>
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Check All"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <Divider />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Appointment and recall reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Glasses / Contact lens pickup reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Contact lens replacement reminders (if applicable)"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Welcome messages, appreciation follow-ups, surveys, and birthday greetings"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                
                
              </Box>
            </Grid>
          </Grid>

           {/* Automated Phone Call Prefereece Card */}
           <Grid
            container
            sx={{ justifyContent: "space-between" ,marginTop:2}}
            columnSpacing={{ sm: 1, md: 2 }}
          >
            <Grid item xs={12} md={4}  mt={2}>
              <ListItemText
                primary="Automated Telephone Contact Preferences"
                secondary={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <span>Your Telephone number: 1234567890</span>
                    <IconButton
                      size="small"
                      onClick={() => setEmailShow(!editEmailShow)}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Box>
                }
                sx={{ textAlign: "left" }}
              />
              {editEmailShow && (
                <Box sx={{ borderRadius: 2, bgcolor: "#F4F5F8", padding: 2 }}>
                  <TextField label="Your Number" size="small" />
                  <Box marginTop={2} marginBottom={2}>
                    <Button
                      variant="contained"
                      sx={{
                        ml: 1,
                        backgroundColor: clinicData.secondaryColor,
                        color: "#fff",
                      }}
                    >
                      Update
                    </Button>
                    {/** Cancel */}
                    <Button
                      variant="outlined"
                      sx={{ ml: 1, color: clinicData.secondaryColor }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              )}
              <FormControl size="small" sx={{ mt: 2, minWidth: 200 }}>
                <InputLabel>Contact Method</InputLabel>
                <Select
                  value={contactMethod}
                  onChange={(e) => setContactMethod(e.target.value)}
                  label="Contact Method"
                >
                  <MenuItem value="disabled" disabled>
                    Disabled
                  </MenuItem>
                  <MenuItem value="primary">Primary</MenuItem>
                  <MenuItem value="secondary">Secondary</MenuItem>
                  <MenuItem value="Tertiary">Tertiary</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              md={8}
              mt={2}
              sx={{
                flexGrow: 0,
                flexBasis: "auto",
                width: { xs: "100%", md: "67%" },
              }}
            >
              <Box sx={{ borderRadius: 3, bgcolor: "#F4F6F8", padding: 3 }}>
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Check All"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <Divider />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Appointment and recall reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
                <FormControlLabel
                  control={
                    <Switch
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: clinicData.secondaryColor,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: clinicData.secondaryColor,
                          },
                      }}
                    />
                  }
                  label="Glasses / Contact lens pickup reminders"
                  labelPlacement="start"
                  sx={{ 
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: 2,
                    fontSize: { xs: "0.8rem", sm: "1rem" }, // Smaller font size on mobile
                    "& .MuiTypography-root": { fontSize: { xs: "0.8rem", sm: "1rem" } }, // Target label text
                    "& .MuiSwitch-root": { transform: { xs: "scale(0.8)", sm: "scale(1)" } } // Scale down switch on mobile
                }}
                />
               
              </Box>
            </Grid>
          </Grid>


          {/* Form */}
          <Box
            component="form"
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            marginTop={3}
          >
            <FormControlLabel 
                control={<Checkbox />} 
                label="I (Patient Name), hereby express my consent to be contacted electronically for the above purposes."
              />
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: clinicData.secondaryColor,
                color: "#fff",
                py: 1.5,
                fontSize: "16px",
                transition: "transform 0.2s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              Submit Preferences
            </Button>
          </Box>
        </Paper>
      </Slide>

      {clinicData && <BottomFooter clinicData={clinicData} />}
    </Box>
  );
}

export default CommPrefs;
